import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=0ed5dcdb&scoped=true&"
import script from "./slide.vue?vue&type=script&lang=js&"
export * from "./slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5dcdb",
  null
  
)

export default component.exports